const state = {
  collapse: false,
  device: 'desktop',
  hidden: false,
  markhidden: false,
  webConfig: '',
  https: '',
  api_url: '',
  sdk_api_url: '',
}

const getters = {
  collapse: (state) => state.collapse,
  device: (state) => state.device,
  hidden: (state) => state.hidden,
  markhidden: (state) => state.markhidden,
  webConfig: (state) => state.webConfig,
  https: (state) => state.https,
  api_url: (state) => state.api_url,
  sdk_api_url: (state) => state.sdk_api_url,
}

const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    state.collapse = !state.collapse
  },
  CLOSE_SIDEBAR: (state) => {
    state.collapse = true
  },
  OPEN_SIDEBAR: (state) => {
    state.collapse = false
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_HIDDEN: (state, hidden) => {
    state.hidden = hidden === '1'
  },
  SET_MARKHIDDEN: (state, markhidden) => {
    state.markhidden = markhidden === '1'
  },
  SET_WEBCONFIG: (state, webConfig) => {
    state.webConfig = webConfig
  },
  SET_HTTPS: (state, https) => {
    state.https = https
  },
  SET_APIURL: (state, api_url) => {
    state.api_url = api_url
  },
  SET_SDKAPIURL: (state, sdk_api_url) => {
    state.sdk_api_url = sdk_api_url
  },
}

const actions = {
  toggleCollapse({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }) {
    commit('CLOSE_SIDEBAR')
  },
  openSideBar({ commit }) {
    commit('OPEN_SIDEBAR')
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setHidden({ commit }, hidden) {
    commit('SET_HIDDEN', hidden)
  },
  setMarkHidden({ commit }, markhidden) {
    commit('SET_MARKHIDDEN', markhidden)
  },
  setWebConfig({ commit }, webConfig) {
    commit('SET_WEBCONFIG', webConfig)
  },
  setHttps({ commit }, https) {
    commit('SET_HTTPS', https)
  },
  setAPIURL({ commit }, api_url) {
    commit('SET_APIURL', api_url)
  },
  setSDKAPIURL({ commit }, sdk_api_url) {
    commit('SET_SDKAPIURL', sdk_api_url)
  },
}

export default { state, getters, mutations, actions }
